import axios from "axios";
import config from "../config";

/**
 * Format date as "Nov 19 2025" (Month Date Year)
 * @param {Date|string} date - Date object or date string
 * @returns {string} Formatted date string or 'N/A' if invalid
 */
export const formatDate = (date) => {
    if (!date) return 'N/A';
    
    try {
        const dateObj = typeof date === 'string' ? new Date(date) : date;
        
        if (isNaN(dateObj.getTime())) {
            return 'N/A';
        }
        
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const month = months[dateObj.getMonth()];
        const day = dateObj.getDate();
        const year = dateObj.getFullYear();
        
        return `${month} ${day} ${year}`;
    } catch (error) {
        console.error('Error formatting date:', error);
        return 'N/A';
    }
};

/**
 * Format date with time as "Nov 19 2025, 2:30 PM"
 * @param {Date|string} date - Date object or date string
 * @returns {string} Formatted date string with time or 'N/A' if invalid
 */
export const formatDateWithTime = (date) => {
    if (!date) return 'N/A';
    
    try {
        const dateObj = typeof date === 'string' ? new Date(date) : date;
        
        if (isNaN(dateObj.getTime())) {
            return 'N/A';
        }
        
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const month = months[dateObj.getMonth()];
        const day = dateObj.getDate();
        const year = dateObj.getFullYear();
        
        let hours = dateObj.getHours();
        const minutes = dateObj.getMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        const minutesStr = minutes < 10 ? '0' + minutes : minutes;
        
        return `${month} ${day} ${year}, ${hours}:${minutesStr} ${ampm}`;
    } catch (error) {
        console.error('Error formatting date with time:', error);
        return 'N/A';
    }
};

// Utility function to get patient from backend
export const handleGetUser = async (patientId, idType = 'other_id') => {
    try {
        const header = { "Authorization": "Token " + localStorage.getItem("optha-token") };
        const userProfile = JSON.parse(localStorage.getItem('user_profile'));
        const healthFacilityId = userProfile?.health_facility?.id;

        const queryParams = new URLSearchParams();
        queryParams.append(idType, patientId);
        if (healthFacilityId) {
            queryParams.append('health_facility_id', healthFacilityId);
        }

        const response = await axios.get(
            `${config.API_BASE_URL}/api/auth/patients/?${queryParams.toString()}`,
            { headers: header }
        );
        if (response?.data?.results?.length > 0) {
            const patient = response.data.results[0];
            return patient;
        } else {
            return null;
        }

    } catch (error) {
        console.error("Error fetching patient:", error);
        return null;
    }
}; 